/**
 * Client-side org cookie helpers (non-HttpOnly).
 * Separated from cookies.ts to avoid importing next/headers into client bundles.
 */

const ORG_COOKIE_NAME = "builderOrgId";
const ORG_COOKIE_MAX_AGE = 365 * 24 * 60 * 60; // 1 year

/** Set org ID cookie from client-side */
export function setOrgCookie(orgId: string): void {
  if (typeof document === "undefined") return;
  const secure = window.location.protocol === "https:" ? ";Secure" : "";
  document.cookie = `${ORG_COOKIE_NAME}=${orgId};Path=/;SameSite=Lax;Max-Age=${ORG_COOKIE_MAX_AGE}${secure}`;
}

/** Read org ID cookie from client-side */
export function getOrgCookie(): string | null {
  if (typeof document === "undefined") return null;
  const match = document.cookie.match(
    new RegExp(`(?:^|; )${ORG_COOKIE_NAME}=([^;]*)`)
  );
  return match ? decodeURIComponent(match[1]) : null;
}

/** Clear org ID cookie from client-side */
export function clearOrgCookie(): void {
  if (typeof document === "undefined") return;
  document.cookie = `${ORG_COOKIE_NAME}=;Path=/;Max-Age=0`;
}
